<template>
  <input
    type="hidden"
    :name="p_surveyItem.surveyItemKey"
    :value="p_objValues[p_surveyItem.surveyItemKey]"
  />
</template>
<script>
import { mapMutations } from 'vuex';

export default {
  name: 'SurveyItemHide',

  props: {
    p_surveyItem: {
      type: Object,
      default: () => ({}),
    },

    p_objValues: {
      type: Object,
      default: () => ({}),
    },
  },

  methods: {
    ...mapMutations('Mixins/Survey', {
      mm_UPDATE_SURVEY_ITEM: 'UPDATE_SURVEY_ITEM',
    }),
  },

  created() {
    this.mm_UPDATE_SURVEY_ITEM({
      ...this.p_surveyItem,
      i_isReady: true,
    });
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
